'use strict';

angular.module('msCore').service('loadingScreenSvc', ['$timeout', '$templateCache', '$document', '$localStorage', '$log', 'providerSvc', function ($timeout, $templateCache, $document, $localStorage, $log, providerSvc) {

  function createLoadingScreen(organizationName, callback, createHidden) {
    immediateRemoveLoadingScreen();
    // Show generic loading screen
    // - Use-case: we don't yet have the organizationName
    if (organizationName === 'myStrength') {
      _buildLoadingScreen(null, null);
      _cacheLoadingScreen();
      _initLoadingScreen(callback, createHidden);
      return;
    }

    // Wait until we get the header images before doing anything.
    // This avoids a visual flash when the image loads.
    providerSvc.getAllHeaderImages().then(function (data) {
      if (_.isUndefined(data)) {
        data = [null];
        $log.error('No Provider Header found, using text fallback.', organizationName);
      }

      data.forEach(function (imageUrl) {
        _buildLoadingScreen(imageUrl, organizationName);
        // Save it to localStorage to be passed into the app.
        _cacheLoadingScreen();
      });

      _initLoadingScreen(callback, createHidden);
    });
  }

  function getCreatedLoadingScreen() {
    var loadingTemplate = $localStorage.loadingScreen;
    if (loadingTemplate) {
      $timeout(function () {
        var loadingScreen = $document[0].getElementById('vNextLoading');

        if (loadingScreen) {
          loadingScreen.classList.remove('hide');
          // Wait 2s for stuff to load. 2s should cover most connections/devices.
          $timeout(function () {

            var hideLoadingScreen = $timeout(function () {
              loadingScreen.classList.add('hide');
              $timeout.cancel(hideLoadingScreen);

              // Wait for the transition to finish, remove it from the DOM.
              var removeLoadingScreen = $timeout(function () {
                if (loadingScreen.parentNode) {
                  loadingScreen.parentNode.removeChild(loadingScreen);
                  $timeout.cancel(removeLoadingScreen);
                }
                immediateRemoveLoadingScreen();
              }, 400);
            }, 2000);
          });
        } else {
          $document[0].body.insertAdjacentHTML('afterbegin', loadingTemplate);
          loadingScreen = $document[0].getElementById('vNextLoading');
        }
      });
    }
  }

  function removeLoadingScreen() {
    var loadingScreen = $document[0].getElementById('vNextLoading');

    // Hide loading screen, if present
    if (loadingScreen) {
      // This timeout used to prevent UI jank when replacing a generic loading page with co branded one
      $timeout(function () {
        loadingScreen.classList.add('hide');

        // This timeout removes original loading screen from document after animation completes
        $timeout(function () {
          if (loadingScreen.parentNode) {
            loadingScreen.parentNode.removeChild(loadingScreen);
          }
          immediateRemoveLoadingScreen();
        }, 1000);
      }, 500);
    }
  }

  function immediateRemoveLoadingScreen() {
    var loadingScreen = $document[0].getElementById('vNextLoading');

    if (loadingScreen) {
      loadingScreen.classList.add('hide');

      if (loadingScreen.parentNode) {
        loadingScreen.parentNode.removeChild(loadingScreen);
      }

      immediateRemoveLoadingScreen();
    }
  }

  function _buildLoadingScreen(imageUrl, orgName) {
    var cobrandingLogo = new Image();
    cobrandingLogo.src = imageUrl;
    cobrandingLogo.alt = orgName;

    // Fallback to the Org's name if there are no Header Images.
    if (imageUrl === null) {
      cobrandingLogo = $document[0].createElement('h1');
      cobrandingLogo.innerHTML = orgName !== null ? orgName : '';
    }

    // Get the loading screen template and insert it into the DOM
    var loadingOverlay = $templateCache.get('core/pages/loading-overlay.html');
    $document[0].body.insertAdjacentHTML('afterbegin', loadingOverlay);

    if (imageUrl && orgName) {
      var introLine = $document[0].querySelector('#vNextLoading .intro-line');
      if (introLine && introLine.classList) {
        introLine.classList.remove('hide');
      }
    }

    // Insert the cobranding logo(s) into the template
    var figure = $document[0].getElementById('cobranding-logo');
    figure.appendChild(cobrandingLogo);
  }

  function _cacheLoadingScreen() {
    // Save it to localStorage to be passed into the app.
    var XMLS = new XMLSerializer();
    $localStorage.loadingScreen = XMLS.serializeToString($document[0].getElementById('vNextLoading'));
  }

  function _initLoadingScreen(callback, createHidden) {
    var loadingScreen = $document[0].getElementById('vNextLoading');

    // Make the loading screen visible. This needs to be slightly delayed
    // for the CSS transition to kick in.
    if (loadingScreen && !createHidden) {
      $timeout(function () {
        loadingScreen.classList.remove('hide');
      }, 10);
    }

    // Give the screen a chance to fade in, then navigate.
    $timeout(function () {
      callback();
    }, 300);
  }

  return {
    createLoadingScreen: createLoadingScreen,
    getCreatedLoadingScreen: getCreatedLoadingScreen,
    removeLoadingScreen: removeLoadingScreen,
    immediateRemoveLoadingScreen: immediateRemoveLoadingScreen
  };
}]);